module.exports = __webpack_public_path__ + "img/promotion-no.275dd103.svg";